import { parsearUrlStorage, refAFirmar } from "@/lib/urlFirmada";

const RE_MIFIEL = /\/?api\/v1\/documents\/([^/]+)\/file(?:_signed)?(?:\?.*)?$/i;

/** Id del documento Mifiel si la URL es `/api/v1/documents/<id>/file`, o `null`. */
export function idDocumentoMifiel(url: string): string | null {
  return url.match(RE_MIFIEL)?.[1] ?? null;
}

/**
 * Bucket y ruta que el visor tiene que firmar, o `null` si la URL se usa tal cual.
 *   - URL de Storage de este proyecto (cualquier bucket, publica o firmada): se firma con el
 *     helper central (`refAFirmar`). Una URL de OTRO proyecto (filas de Preview que apuntan
 *     a Produccion) se usa tal cual: firmarla daria un token para un objeto que no existe.
 *   - Documento Mifiel: lo resuelve la Edge Function (devuelve `null`).
 *   - Ruta relativa: es del bucket privado `firmas-digitales`.
 */
export function rutaStorageDeRecurso(url: string, hostProyecto: string): { bucket: string; path: string } | null {
  if (/^https?:\/\//i.test(url) || url.startsWith("blob:") || url.startsWith("data:")) {
    return refAFirmar(url, hostProyecto);
  }
  if (RE_MIFIEL.test(url)) return null;
  const ref = parsearUrlStorage(url);
  if (ref) return ref;
  return { bucket: "firmas-digitales", path: url.replace(/^\/+/, "") };
}
